import { PaletteColor, darken, lighten, alpha } from '@mui/material/styles';
import { componentColors as themeComponentColors } from '../assets/themes/default';

export const extendColor = (color: PaletteColor) => {
  return {
    ...color,
    outlinedHoverBg: getOutlinedHoverBg(color), // deprecated
    outlinedRestingBorder: getOutlinedRestingBorder(color), // deprecated
    containedHoverBg: getContainedHoverBg(color), // deprecated
    background: getBackgroundColor(color), // deprecated
    content: getContentColor(color), // deprecated
    hover: getHover(color),
    selected: getOutlinedHoverBg(color),
    focus: getFocus(color),
    focusVisible: getFocusVisible(color),
    outlinedBorder: getOutlinedRestingBorder(color),
  };
};

export const componentColors = (color: PaletteColor) => ({
  divider: alpha(color.main, 0.12),
  backdropOverlay: alpha(color.main, 0.5), // deprecated
  disabled: alpha(color.main, 0.26), // deprecated
  chip: alpha(color.main, 0.08), // deprecated
  filledInputBackground: alpha(color.main, 0.09), // deprecated
  filledInputBackgroundDisabled: alpha(color.main, 0.12), // deprecated
  outlinedBorder: alpha(color.main, 0.23), // deprecated
  backgroundItemHover: alpha(color.main, 0.04), // deprecated
  actionBorderDisabled: alpha(color.main, 0.12), // deprecated
  actionDisabled: alpha(color.main, 0.26), // deprecated
  highlightBorder: alpha(color.dark, 1.0), // deprecated
  background: getBackgroundColor(color),
  content: getContentColor(color),
});

export const getBackgroundColor = (color: PaletteColor) => {
  if (themeComponentColors[color.main]) return themeComponentColors[color.main].background;
  return lighten(color.main, 0.9);
};

export const getContentColor = (color: PaletteColor) => {
  if (themeComponentColors[color.main]) return themeComponentColors[color.main].content;
  return darken(color.main, 0.6);
};

export const getContainedHoverBg = (color: PaletteColor) => darken(color.main, 0.3); // deprecated

export const getOutlinedRestingBorder = (color: PaletteColor) => alpha(color.main, 0.5);

export const getOutlinedHoverBg = (color: PaletteColor) => alpha(color.main, 0.08);

export const getHover = (color: PaletteColor) => alpha(color.main, 0.04);

export const getFocus = (color: PaletteColor) => alpha(color.main, 0.12);

export const getFocusVisible = (color: PaletteColor) => alpha(color.main, 0.3);
